import { SERVICE_CATALOG } from './serviceTaxonomy'

export const homeSections = [
  { id: 'home-services', label: '서비스 카테고리', status: 'ACTIVE', order: 1, source: 'service_categories', description: '메인 서비스 카테고리 바로가기' },
  { id: 'home-directors', label: '추천 디렉터', status: 'ACTIVE', order: 2, source: 'featured_directors', description: '운영 추천 + 큐레이션 디렉터 노출' },
  { id: 'home-portfolios', label: '추천 포트폴리오', status: 'ACTIVE', order: 3, source: 'featured_portfolios', description: '대표 작업 사례 노출' },
  { id: 'home-stories', label: '디팬 이야기', status: 'ACTIVE', order: 4, source: 'stories', description: '발행된 스토리 노출' },
  { id: 'home-events', label: '이벤트', status: 'ACTIVE', order: 5, source: 'events', description: '현재 진행 중 이벤트' },
  { id: 'home-director-cta', label: '디렉터 참여 CTA', status: 'ACTIVE', order: 6, source: 'banners', description: '디렉터 가입 유도 영역' },
  { id: 'home-app', label: '앱 다운로드', status: 'ACTIVE', order: 7, source: 'banners', description: 'App Store / Google Play 안내' },
]

export const featuredDirectors = [
  { id: 'fd-001', directorId: 'director-001', name: '스튜디오 빛결', order: 1, status: 'ACTIVE', reason: '운영 추천', startAt: '2026-08-01', endAt: '2026-08-31' },
  { id: 'fd-002', directorId: 'director-003', name: '어라운드 데이', order: 2, status: 'ACTIVE', reason: '포트폴리오 품질', startAt: '2026-08-01', endAt: '2026-08-31' },
  { id: 'fd-003', directorId: 'director-002', name: '모먼트 플랜', order: 3, status: 'ACTIVE', reason: '신규 추천', startAt: '2026-08-05', endAt: '2026-08-31' },
]

export const featuredPortfolios = [
  { id: 'fp-001', portfolioId: 'portfolio-001', title: '아이보리 플라워 생일 카페', order: 1, status: 'ACTIVE', reason: '대표 작업' },
  { id: 'fp-002', portfolioId: 'portfolio-002', title: '데뷔 기념 팬미팅 패키지', order: 2, status: 'ACTIVE', reason: '팬미팅 추천' },
]

const serviceMetrics = {
  'svc-001': { shortDescription: '생일 카페 공간 기획부터 포토존·플라워·오브제까지', requestCount: 182, directorCount: 74, questionCount: 8, featured: true },
  'svc-002': { shortDescription: '지하철 역사·옥외 전광판 광고의 매체 선정부터 소재 제작·송출까지', requestCount: 116, directorCount: 29, questionCount: 6, featured: true },
  'svc-003': { shortDescription: '촬영 경험을 중심으로 포토존과 공간 전체 동선을 함께 연출', requestCount: 155, directorCount: 63, questionCount: 7, featured: true },
  'svc-004': { shortDescription: '포토카드·아크릴·패키지 등 팬 서포트용 커스텀 굿즈 제작', requestCount: 103, directorCount: 46, questionCount: 6, featured: true },
  'svc-005': { shortDescription: '팬미팅 웰컴존·현장 운영·특전 및 패키징 기획', requestCount: 94, directorCount: 35, questionCount: 7, featured: false },
  'svc-006': { shortDescription: '팬덤 전시와 팝업형 공간의 기획·디자인·설치·운영', requestCount: 88, directorCount: 38, questionCount: 7, featured: false },
}

export const serviceDefinitions = SERVICE_CATALOG.map((item, index) => ({
  ...item,
  status: 'ACTIVE',
  order: index + 1,
  ...serviceMetrics[item.id],
}))

export const quoteQuestions = [
  { id: 'q-001', serviceId: 'svc-001', serviceName: '생일 카페', key: 'event_date', label: '행사 예정일', type: 'DATE', required: true, order: 1, options: [] },
  { id: 'q-002', serviceId: 'svc-001', serviceName: '생일 카페', key: 'region', label: '희망 지역', type: 'REGION', required: true, order: 2, options: [] },
  { id: 'q-003', serviceId: 'svc-001', serviceName: '생일 카페', key: 'budget', label: '예산 범위', type: 'BUDGET', required: true, order: 3, options: ['100만원 미만','100~200만원','200~300만원','300만원 이상'] },
  { id: 'q-004', serviceId: 'svc-001', serviceName: '생일 카페', key: 'mood', label: '원하는 분위기', type: 'MULTI_SELECT', required: false, order: 4, options: ['미니멀','러블리','고급스러운','화이트·아이보리','모던'] },
  { id: 'q-005', serviceId: 'svc-001', serviceName: '생일 카페', key: 'reference', label: '참고 이미지', type: 'FILE', required: false, order: 5, options: [] },
  { id: 'q-006', serviceId: 'svc-003', serviceName: '포토존·공간 연출', key: 'space_size', label: '공간 규모', type: 'TEXT', required: false, order: 1, options: [] },
]

export const memberOperations = {
  'user-001': {
    emailVerified: true,
    identities: [{ provider: 'EMAIL', connectedAt: '2026-07-18' }],
    consents: [
      { name: '이용약관', version: 'v1.0', agreed: true, agreedAt: '2026-07-18' },
      { name: '개인정보 수집·이용', version: 'v1.0', agreed: true, agreedAt: '2026-07-18' },
      { name: '마케팅 수신', version: 'v1.0', agreed: false, agreedAt: null },
    ],
    notificationPreferences: ['견적 도착', '결제·환불', '프로젝트 상태'],
    favoriteDirectors: ['스튜디오 빛결', '어라운드 데이'],
    favoritePortfolios: ['아이보리 플라워 생일 카페'],
    reviewIds: ['review-001'],
  },
  'user-002': {
    emailVerified: true,
    identities: [{ provider: 'KAKAO', connectedAt: '2026-07-25' }],
    consents: [{ name: '이용약관', version: 'v1.0', agreed: true, agreedAt: '2026-07-25' }, { name: '마케팅 수신', version: 'v1.0', agreed: true, agreedAt: '2026-07-25' }],
    notificationPreferences: ['견적 도착', '프로젝트 상태'],
    favoriteDirectors: ['모먼트 플랜'], favoritePortfolios: [], reviewIds: [],
  },
}

export const directorOperations = {
  'director-001': {
    shortHeadline: '생일 카페·공간 연출·플라워를 한 번에 설계하는 팬 서포트 디렉터',
    keywords: ['생일카페','포토존','플라워 장식','공간 연출','굿즈 디스플레이'],
    serviceScope: '기획, 디자인, 장식, 현장 세팅, 굿즈 디스플레이, 설치 및 철수',
    processDescription: '요청 확인 → 1:1 상담 → 콘셉트 제안 → 세부 견적 확정 → 제작 → 현장 설치 및 철수',
    aiConsent: true,
    mediaCount: 18,
    faq: [
      { question: '행사 준비는 최소 언제 문의해야 하나요?', answer: '일반적인 공간 연출은 최소 3~4주 전에 문의해주시면 안정적으로 진행할 수 있습니다.' },
      { question: '대관 장소가 정해지지 않아도 상담할 수 있나요?', answer: '네. 희망 지역과 예상 인원을 알려주시면 적합한 공간 대관부터 함께 제안할 수 있습니다.' },
    ],
    settlement: { bank: '신한은행', holder: '김민지', maskedAccount: '신한은행 · ****-6789', verificationStatus: 'VERIFIED', updatedAt: '2026-08-08' },
  },
}

export const quoteRequestOperations = {
  'qr-001': {
    answers: [
      { question: '행사 예정일', answer: '2026-10-18' },
      { question: '희망 지역', answer: '서울 성수동' },
      { question: '예산 범위', answer: '1,200,000원 ~ 1,700,000원' },
      { question: '원하는 분위기', answer: '화이트·아이보리, 고급스러운, 따뜻한 느낌' },
    ],
    files: [
      { id: 'file-qr-001-1', name: 'reference_cafe_01.jpg', type: '참고 이미지', visibility: 'PRIVATE' },
      { id: 'file-qr-001-2', name: 'reference_flower_02.jpg', type: '참고 이미지', visibility: 'PRIVATE' },
      { id: 'file-qr-001-3', name: 'space_floorplan.pdf', type: '공간 도면', visibility: 'PRIVATE' },
    ],
    targets: [
      { directorId: 'director-001', name: '스튜디오 빛결', status: 'QUOTE_SUBMITTED', sentAt: '2026-08-10 09:20' },
      { directorId: 'director-002', name: '모먼트 플랜', status: 'VIEWED', sentAt: '2026-08-10 09:20' },
      { directorId: 'director-003', name: '어라운드 데이', status: 'QUOTE_SUBMITTED', sentAt: '2026-08-10 09:20' },
      { directorId: 'director-004', name: '오브젝트룸', status: 'DECLINED', sentAt: '2026-08-10 09:20' },
    ],
    statusHistory: [
      { label: '요청서 제출', detail: '고객 원문 및 첨부 저장', at: '2026-08-10 09:06' },
      { label: 'AI 분석 완료', detail: '구조화 분석 및 검색 문서 생성', at: '2026-08-10 09:07' },
      { label: '디렉터 전달', detail: '추천 후보 5명에게 요청 전달', at: '2026-08-10 09:20' },
      { label: '견적 수신', detail: '2건 도착', at: '2026-08-10 09:45' },
    ],
  },
}

export const aiRuns = [
  { id: 'ai-run-001', feature: 'QUOTE_STRUCTURE', subject: 'DF-QR-20260810-001', model: 'gpt-5.4-nano-2026-03-17', promptVersion: 'quote-structure-v0.4', status: 'COMPLETED', inputTokens: 1220, cachedTokens: 640, outputTokens: 188, costUsd: 0.0062, latencyMs: 710, createdAt: '2026-08-10T09:07:00+09:00', inputHash: 'sha256:74e2…c91a', humanOverride: false },
  { id: 'ai-run-002', feature: 'DIRECTOR_PROFILE', subject: '스튜디오 빛결', model: 'gpt-5.4-mini-2026-03-17', promptVersion: 'director-profile-v0.3', status: 'COMPLETED', inputTokens: 4920, cachedTokens: 2380, outputTokens: 612, costUsd: 0.052, latencyMs: 1640, createdAt: '2026-08-10T09:18:00+09:00', inputHash: 'sha256:9b21…1c02', humanOverride: false },
  { id: 'ai-run-003', feature: 'CURATION_RERANK', subject: 'DF-QR-20260810-001', model: 'gpt-5.4-mini-2026-03-17', promptVersion: 'curation-rerank-v0.2', status: 'COMPLETED', inputTokens: 1780, cachedTokens: 1020, outputTokens: 224, costUsd: 0.021, latencyMs: 980, createdAt: '2026-08-10T09:19:00+09:00', inputHash: 'sha256:22ac…88d1', humanOverride: false },
  { id: 'ai-run-004', feature: 'MOCKUP_IMAGE', subject: 'DF-QT-20260810-0012', model: 'gpt-image-2-2026-04-21', promptVersion: 'mockup-image-v0.2', status: 'FAILED', inputTokens: 0, cachedTokens: 0, outputTokens: 0, costUsd: 0, latencyMs: 2410, createdAt: '2026-08-10T09:34:00+09:00', inputHash: 'sha256:a813…09fe', humanOverride: false, error: 'provider_timeout' },
]
